import { adfModelTypeMap } from './../consts/adf-model-type-map-const';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { dynamicsEntityMetadata } from './dynamics-entity-metadata';
import { getUpsertOption } from 'app/registries/consts/copy-job-const';

export const dynamicsCrmEntityMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.dynamicsCRM.datasetType,
    supportLinkedServiceTypes: [adfModelTypeMap.dynamicsCRM.linkedServiceType],
    displayName: stringResources.DynamicsCRMEntity_DisplayText,
    datasetKind: 'table',
    isSource: true,
    isSink: true,
    notSupportTypeConversionWhenSource: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    supportCreatedAsV2: true,
    supportDataFlowSource: true,
    supportDataFlowSink: true,
    icon: {
        className: 'svg-i-100x100-dynamics_crm'
    },
    tableNameDisplay: stringResources.TableNameDisplay_EntityName,
    tableNamePlural: stringResources.Entities,
    isFirstClass: true,
    category: ['ServicesApps'],
    copySinkControls: dynamicsEntityMetadata.copySinkControls,
    dataflowSourceControls: dynamicsEntityMetadata.dataflowSourceControls,
    dataflowSinkControls: dynamicsEntityMetadata.dataflowSinkControls,
    copyJob: {
        updateMethod: {
            supportUpdateMethod: true,
            options: [getUpsertOption()],
            updateMethodProperties: ['writeBehavior', 'alternateKeyName'],
            singleUpsertKeyColumn: true,
            upsertKeyColumnLabel: stringResources.ModelName_AlternateKey,
            upsertKeyColumnRequired: false
        }
    }
};
